export default "__VITE_ASSET__LjX8UqkQ__"